import { useNavigate } from 'react-router-dom';

import { useSession } from '../../lib/session';
import { useUI } from '../../lib/ui';
import Styles from './GuestPrompt.module.css';

const HEADLINE = {
  milestone: 'Nice work. Keep it?',
  leaderboard: 'Leaderboards need an account.',
};

const GuestPrompt = () => {
  const navigate = useNavigate();
  const signup = useUI((s) => s.signup);
  const close = useUI((s) => s.closeSignup);
  const user = useSession((s) => s.user);

  if (!signup || user) return null;

  return (
    <div className={Styles.card} role="dialog" aria-label="Create an account">
      <h3 className={Styles.title}>{HEADLINE[signup.reason] || HEADLINE.milestone}</h3>
      <p className={Styles.text}>Save your band room progress &amp; unlock the Leaderboards!</p>
      <div className={Styles.actions}>
        <button
          type="button"
          className={Styles.primary}
          onClick={() => {
            close();
            navigate('/signup');
          }}
        >
          Create free account
        </button>
        <button type="button" className={Styles.later} onClick={close}>
          Maybe later
        </button>
      </div>
    </div>
  );
};

export default GuestPrompt;